export const XLM = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="16"
      cy="16"
      r="15.9628"
      fill="white"
      stroke="#CCD1DC"
      strokeWidth="0.0744186"
    />
    <g clipPath="url(#clip0_1_3223)">
      <path
        d="M22.3069 10.5068L20.189 11.5858L9.96163 16.7951C9.92704 16.5314 9.90964 16.2656 9.90953 15.9996C9.91093 14.9382 10.1896 13.8955 10.718 12.9749C11.2463 12.0543 12.006 11.2877 12.9218 10.7511C13.8376 10.2144 14.8777 9.92631 15.939 9.91531C17.0004 9.90431 18.0463 10.1708 18.973 10.6883L20.1853 10.0707L20.3661 9.97839C19.2556 9.17236 17.9438 8.68906 16.5758 8.58192C15.2078 8.47479 13.8368 8.74798 12.6143 9.3713C11.3918 9.99462 10.3655 10.9438 9.64875 12.114C8.932 13.2841 8.55274 14.6296 8.55288 16.0018C8.55288 16.1914 8.56008 16.3801 8.57446 16.5682C8.59461 16.8344 8.53556 17.1007 8.40473 17.3335C8.2739 17.5663 8.07714 17.7552 7.83921 17.8764L7.19995 18.2024V19.7228L9.082 18.7635L9.69149 18.4524L10.292 18.1466L21.0738 12.653L22.2853 12.0361L24.7895 10.7598V9.24016L22.3069 10.5068Z"
        fill="black"
      />
      <path
        d="M24.7895 12.2809L10.9045 19.3507L9.69297 19.9691L7.19995 21.2394V22.7583L9.67586 21.4969L11.7938 20.4178L22.0316 15.2011C22.0662 15.4666 22.0836 15.7341 22.0837 16.0018C22.083 17.0645 21.8044 18.1085 21.2756 19.0302C20.7467 19.9519 19.9859 20.7193 19.0688 21.2561C18.1517 21.7929 17.1102 22.0806 16.0476 22.0904C14.9849 22.1003 13.9382 21.832 13.0113 21.3123L12.9369 21.3518L11.6226 22.0215C12.7329 22.8276 14.0444 23.311 15.4122 23.4184C16.78 23.5258 18.1509 23.253 19.3734 22.6301C20.5958 22.0072 21.6223 21.0585 22.3394 19.8887C23.0564 18.719 23.4362 17.3738 23.4366 16.0018C23.4366 15.8106 23.4292 15.6193 23.415 15.4303C23.3949 15.1641 23.4539 14.8979 23.5846 14.6651C23.7153 14.4324 23.9118 14.2434 24.1495 14.122L24.7895 13.796V12.2809Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_3223">
        <rect
          width="17.5896"
          height="14.8837"
          fill="white"
          transform="translate(7.19995 8.56006)"
        />
      </clipPath>
    </defs>
  </svg>
);
